export default function Blogs() {
  return (
    <main
      className="text-center"
      style={{
        maxWidth: "992px",
        margin: "0 auto",
      }}
    >
      <h1 className="p-4 text-center">Questions & Answers</h1>

      <div className="p-4 pt-0 flex flex-col gap-4">
        <h2>How will you improve the performance of a React Application?</h2>

        <p>
          To improve the performance of a React application we can follow a few
          rules and apply a few techniques. If we perform computation intensive
          tasks in our application, we should memoize the result using
          <code>React.memo</code>, <code>useMemo</code>,{" "}
          <code>useCallback</code>. And to improve network performance and
          developer performance (productivity) we should use a meta framework
          like such <code>Astro JS</code>, <code>Next.js</code>,{" "}
          <code>Gatsby JS</code>, etc.
        </p>

        <h2>
          What are the different ways to manage a state in a React application?
        </h2>

        <p>
          There are different ways to manage state in a React application. We
          can use the methods that are built into React such as{" "}
          <code>useState</code>,<code>useReducer</code> and the Context API. Or,
          we can use a state container library like Redux or Zustand. We can use
          finite state machines too, for example the Robot library.
        </p>

        <h2>How does prototypical inheritance work?</h2>

        <p>
          Except a few exceptions (such as arrow functions), every JavaScript
          objects have a link to their prototype object. When accesing a
          property in an Object, the property won't only be sought on the object
          but the prototype of the object, the prototype of the prototype, the
          prototype of the prototype of the prototype, and so until either a
          property is found with the requested name or the end of the chain is
          reached.
        </p>

        <h2>
          Why don't you set the state directly in React? For example, if you
          have <code>const [products, setProducts] = useState([])</code>. Why
          don't you set <code>products = [...]</code> instead, you use the{" "}
          <code>setProducts</code>?
        </h2>

        <p>
          If we set the state directly in React, or <em>technically</em> if we
          redefine the value of the state variable, the value of the variable
          will get changed but there's no way for React to know that it has
          changed. And if it doesn't even know the value of the state has
          changed it won't be able to update the content that depends on the
          state. That's why we have to use the <code>setState</code> function to
          inform React to update the content.
        </p>

        <h2>
          You have an array of products. Each product has a name, price,
          description, etc. How will you implement a search to find products by
          name?
        </h2>

        <p>
          <div className="mockup-code text-left">
            <div className="px-6">
              <span className="block text-gray-400">{`// const products = ...`}</span>
              <span className="block h-4" />
              <span className="block text-[goldenrod]">{`const search = (name) => products.find(product => product.name === name );`}</span>
            </div>
          </div>
        </p>

        <h2>What is a unit test? Why should you write unit tests?</h2>

        <p>
          A unit test is a test where a <code>unit</code>, a small piece of the
          codebase, is tested in an isolated environment. We should write unit
          tests to make sure that the code works correctly in different
          scenarios and to protect the code against future bugs.
        </p>
      </div>
    </main>
  );
}
